import Vue from 'vue';
import App from './App.vue';
import VueScrollTo from 'vue-scrollto';
//import VuePageTransition from 'vue-page-transition';


import AOS from 'aos';
import 'aos/dist/aos.css';
import router from './router';
import store from './store';
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-71229914-10" }
}, router);
Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});


//Vue.use(VuePageTransition);
Vue.mixin({
  methods: {
    onScroll() {
      AOS.refresh();
    }
  }
});
new Vue({
  router,
  store,
  created() {
    window.addEventListener('load', function() {
      AOS.init();
    })    
  },
  render: h => h(App)
}).$mount('#app');
